import moment from 'moment-timezone'
import heartbeat from 'lib/saga/heartbeat'
import { fork, call, put, select, takeLatest } from 'redux-saga/effects'
import { CancelToken } from 'axios'
import { CANCEL } from 'redux-saga'
import { TYPE_MONTHS_TO_DATE } from 'containers/Navigation/const'
import {
  SET_NAVIGATION,
  configureNavigation,
  setNavigationDate
} from 'containers/Navigation/actions'
import { selectNavigationRangeDates } from 'containers/Navigation/selectors'
import api from 'lib/api/client'
import {
  selectTimezone,
  selectToken,
  selectLocation,
  selectActiveType,
  selectLatestPresentMonthKey
} from './selectors'
import Actions, {
  startInit,
  finishInit,
  receiveLocation,
  requestTop,
  receiveTop,
  requestProjects,
  receiveProjects,
  requestPzs,
  receivePzs
} from './actions'

export function * init () {
  yield put(startInit())

  const timezone = yield select(selectTimezone)
  yield put(configureNavigation(TYPE_MONTHS_TO_DATE))
  yield put(setNavigationDate(moment.tz({ hour: 0 }, timezone)))

  const token = yield select(selectToken)
  const id = window.location.pathname.split('/').slice(-2)[0]
  const location = yield call(api.get, `/locations/${id}`, { token })
  yield put(receiveLocation(location))

  yield call(breakdowns)
  yield call(pzs)

  yield put(finishInit())
}

export function * breakdowns () {
  yield put(requestTop())
  const token = yield select(selectToken)
  const { id } = yield select(selectLocation)
  const params = yield select(selectNavigationRangeDates)
  const data = yield call(api.get, `/oee/dashboard/location/${id}/breakdowns`, {
    token,
    params
  })

  yield put(receiveTop(data))
  yield call(projects)
}

export function * projects () {
  const latestMonthKey = yield select(selectLatestPresentMonthKey)

  if (!latestMonthKey) {
    return
  }

  yield put(requestProjects())
  const token = yield select(selectToken)
  const { id } = yield select(selectLocation)
  const activeType = yield select(selectActiveType)
  const params = {
    month: moment(latestMonthKey).format('YYYY-MM-DD'),
    stoppage_description: activeType.label
  }
  const data = yield call(
    api.get,
    `/oee/dashboard/location/${id}/breakdown_projects`,
    {
      token,
      params
    }
  )

  yield put(receiveProjects(data))
}

function getCancellablePzs (id, token, params) {
  const source = CancelToken.source()

  const promise = api.get(`/oee/dashboard/location/${id}/breakdown_pzs`, {
    token,
    params,
    cancelToken: source.token
  })

  promise[CANCEL] = () => source.cancel()

  return promise
}

export function * pzs () {
  yield put(requestPzs())

  const token = yield select(selectToken)
  const { id } = yield select(selectLocation)
  const params = yield select(selectNavigationRangeDates)
  const data = yield call(getCancellablePzs, id, token, params)

  yield put(receivePzs(data))
}

export default function * root () {
  if (process.env.NODE_ENV === 'development') {
    yield fork(heartbeat, 'OEE Breakdown Dashboard')
  }

  yield call(init)

  yield takeLatest(SET_NAVIGATION, breakdowns)
  yield takeLatest(Actions.RECEIVE_TOP, pzs)
  yield takeLatest(Actions.SET_ACTIVE_TYPE, projects)
}
